import React, { useEffect, useRef, useState, useCallback } from 'react';
import { MemberDetailNode, TeamMemberNode } from 'nicehubs-plus';
import { v4 as uuidv4 } from 'uuid';
import { useDispatch, useSelector } from 'react-redux';
import { Person } from 'type/contact';
import { getUnionContacts, searchUnionContacts } from 'model/contact';

// TODO 组件库生成
interface ImemberTransferRef extends HTMLElement {
  filterPlaceholder: string;
  filterMember: (keyword?: string) => void;
  selectAllAble: boolean;
  defaultCheckedKeys: string[];
  disabledNodeMethod: (node: TeamMemberNode | MemberDetailNode) => boolean;
  data: TeamMemberNode;
  addEventListener: any;
  removeEventListener: any;
}

// 该组件作为防腐层，封装 web-component
interface IProps {
  width?: number;
  recommendList?: any;
  recentlyList?: any;
  disabledList: any[] | undefined;
  orgContact?: any;
  onChange: (person: Person) => void;
}

const MemberWrapper: React.FC<IProps> = (props) => {
  const memberRef = useRef<ImemberTransferRef>(null);
  const eventHandlers = {
    change: props.onChange
  };

  const dispatch = useDispatch();
  const [displayContacts, setDisplayContacts] = useState<ContactV2>();
  const unionContacts = useSelector((state: RootState) => state.contact.unionContacts);

  const init = async () => {
    dispatch(
      getUnionContacts({
        callback: (data) => {
          console.log('===displayContacts=init>', data);
          setDisplayContacts(data);
        }
      })
    );
  };

  useEffect(() => {
    // 只在组件挂载后设置属性
    if (memberRef.current) {
      // 直接操作 DOM 属性来传递对象
      memberRef.current.data = displayContacts;

      memberRef.current.disabledNodeMethod = (node: TeamMemberNode | MemberDetailNode) => {
        return props.disabledList ? props.disabledList.findIndex((item) => item.staffId === node.refId) > -1 : false;
      };
    }
  }, [displayContacts]);

  useEffect(() => {
    init();
    if (memberRef.current) {
      if (props.width) {
        memberRef.current.style.width = props.width + 'px';
      }
      // 初始化-监听事件
      Object.entries(eventHandlers).forEach(([event, handler]) => {
        memberRef.current?.addEventListener(event, handler);
      });

      // 卸载时-清除监听
      return () => {
        if (memberRef.current) {
          Object.entries(eventHandlers).forEach(([event, handler]) => {
            memberRef.current?.removeEventListener(event, handler);
          });
        }
      };
    }
  }, []);

  /** 搜索参会人 */
  const filterMember = useCallback(
    (keyword?: string) => {
      if (!keyword) {
        memberRef.current.nodeOrder = 'teamFirst';
        if (unionContacts) {
          setDisplayContacts(unionContacts);
        } else {
          dispatch(
            getUnionContacts({
              callback: (data) => {
                setDisplayContacts(data);
              }
            })
          );
        }
      } else {
        memberRef.current.nodeOrder = 'menberFirst';
        dispatch(
          searchUnionContacts({
            keyword,
            callback: (data) => {
              setDisplayContacts(data);
            }
          })
        );
      }
    },
    [unionContacts]
  );

  /** 筛选参会人 */
  useEffect(() => {
    if (!memberRef.current) return;
    memberRef.current.filterMember = filterMember;
    memberRef.current.filterPlaceholder = '搜索成员、部门、最近会议';
    memberRef.current.nodeOrder = 'teamFirst';
  }, [filterMember]);

  return <ce-member-transfer type="checkTree" ref={memberRef} theme="client" node-key="refId" />;
};

export default MemberWrapper;
